module.exports = __webpack_public_path__ + "img/d6.e8c33a51.png";